import { Stack, Tabs } from '@mantine/core'
import { useQueryParamTab } from 'src/utils/tabQueryParam'
import BooksPage from './BooksPage'
import BooksUniViniPage from 'src/pages/BooksUniViniPage/BooksUniViniPage'

function BooksTabsPage() {
	const tabValues = ['book-univini', 'book-user'] as const
	const { activeTab, handleTabChange } = useQueryParamTab(tabValues, 'book-univini')

	return (
		<Stack
			sx={{
				width: '100%',
				padding: 14,
				border: '1px solid #e6ebe7',
				borderRadius: 10,
				background: '#fff',
			}}
		>
			<Tabs
				value={activeTab}
				onTabChange={handleTabChange}
				keepMounted={false}
				sx={{
					'.mantine-Tabs-list': {
						gap: 12,
						borderBottom: '1px solid #edf2ee',
						paddingBottom: 8,
					},
					'.mantine-Tabs-tab': {
						paddingInline: 14,
						paddingBlock: 8,
						color: '#374151',
						borderRadius: 8,
						fontWeight: 700,
					},
					'.mantine-Tabs-tab[data-active="true"]': {
						color: '#1f7a44',
						background: '#ecfdf3',
					},
				}}
			>
				<Tabs.List>
					<Tabs.Tab value="book-univini" fw={700}>
						Book UniVini
					</Tabs.Tab>
					<Tabs.Tab value="book-user" fw={700}>
						Book User
					</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="book-univini" pt="md">
					<BooksUniViniPage />
				</Tabs.Panel>

				<Tabs.Panel value="book-user" pt="md">
					<BooksPage />
				</Tabs.Panel>
			</Tabs>
		</Stack>
	)
}

export default BooksTabsPage
